module.exports = __webpack_public_path__ + "img/CM.e4a40d17.png";